import type { Draft } from 'immer';
import type { TreePickerItemWithValue } from './TreePickerItem';

export const filterSelectedTreePickerValues = <TKey extends string>(
  item: Draft<TreePickerItemWithValue<TKey>>,
): boolean => {
  if (item.children.length === 0) {
    return item.value === true;
  }

  item.children = item.children.filter(filterSelectedTreePickerValues);
  return item.children.length > 0;
};
